import { formatReportName } from "./formatReportName";

export default formatReportName;
